<template>
  <div class="enter-community-container">
    <el-card v-if="showPage === 'myCommunityTuzhi'">
      <div slot="header" class=" flex justify-between">
        <span>{{ $route.query.name }}</span>
        <el-button type="primary" size="small" @click="goBack">
          返回
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="drawingName" placeholder="图纸名称" clearable />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleQuery">
            <i class="el-icon-search"></i>
            查询
          </el-button>
          <el-button @click="handleReset">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="openAddDialog">
            <i class="el-icon-add"></i>
            添加
          </el-button>
        </el-col>
      </el-row>
      <el-table :data="communityList" border v-loading="loading" style="margin-top: 20px;">
        <el-table-column prop="drawingName" label="图纸名称" align="center" />
        <el-table-column prop="createTime" label="创建时间" align="center" />
        <el-table-column label="附件" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleDownload(row.fileUrl)">
              下载
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="{ row }">
            <el-popconfirm
              title="确认删除该图纸吗？"
              @confirm="del(row)"
            >
              <el-button slot="reference" type="text" style="color: red;" size="small">删除</el-button>
            </el-popconfirm>
            <!-- <el-button type="text" size="small" @click="openTuzhiDialog(row)">
              删除
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pagination" :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" @current-change="handlePageChange" />
    </el-card>

    <el-card v-else>
      <div slot="header" class=" flex justify-between">
        <div>{{ $t('enterCommunity.commercialProcess') }}</div>
        <el-button type="primary" size="small" @click="goBack">
          <i class="el-icon-close"></i>
          {{ $t('enterCommunity.back') }}
        </el-button>
      </div>

      <div class="commercial-content">
        <img src="/img/hc_use.png" alt="Commercial Process">
      </div>
    </el-card>

    <edit-community-area ref="editDialog" @success="fetchCommunityList" />
    <el-dialog title="添加图纸" :visible.sync="dialogVisible" width="500px">
      <div>
        <el-form :model="mergerForm" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
           ref="formRef" label-width="80px">
          <el-form-item label="图纸名称" prop="drawingName">
            <el-input v-model="mergerForm.drawingName" placeholder="请输入图纸名称" />
          </el-form-item>
          <el-form-item label="附件" prop="drawingName">
            <upload-file ref="uploadFileRef" :limit="1" :value="fileList" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitMerger">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryCommunityDrawings, updateCommunityTuzhi,deleteCommunityDrawing } from '@/api/community/enterCommunityApi'
import EditCommunityArea from '@/components/community/editCommunityArea.vue'
import UploadFile from '@/components/upload/cusUpload.vue'
export default {
  name: 'EnterCommunityList',
  components: { EditCommunityArea,UploadFile },
  data() {
    return {
      showPage: 'myCommunityTuzhi',
      loading: false,
      dialogVisible: false,
      drawingName: '',
      communityList: [],
      fileList: [],
      pagination: {
        current: 1,
        size: 999,
        total: 0
      },
      mergerForm: {
        communityId: '',
        drawingName: '',
        fileId: '',
        fileUrl: ''
      }
    }
  },
  mounted() {
    this.fetchCommunityList()
    // communityId drawingName fileId fileUrl

  },
  methods: {
    async del(row) {
      try {
        await deleteCommunityDrawing({
          ...row
        })
        this.$message({
          message: '图纸删除成功',
          type: 'success'
        })
        this.fetchCommunityList()
      } catch (error) {
        console.error('Failed to delete community drawing:', error)
        this.$message({
          message: '图纸删除失败',
          type: 'error'
        })
      }
    },
    handleDownload(fileUrl) {
      window.open(fileUrl)
    },
    openAddDialog() {
      this.dialogVisible = true
      this.mergerForm.communityId = this.$route.query.communityId
      this.mergerForm.drawingName = ''
      this.mergerForm.fileId = ''
      this.mergerForm.fileUrl = ''
    },
    async submitMerger() {
      try {
        this.mergerForm.fileId = this.$refs.uploadFileRef.uploadList[0].name
        this.mergerForm.fileUrl = this.$refs.uploadFileRef.uploadList[0].url
        await updateCommunityTuzhi(this.mergerForm)
        this.$message({
          message: '图纸更新成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.fetchCommunityList()
      } catch (error) {
        console.error('Failed to update community tuzhi:', error)
        this.$message({
          message: '图纸更新失败',
          type: 'error'
        })
      }
    },
    handleQuery() {
      this.pagination.current = 1
      this.fetchCommunityList()
    },
    handleReset() {
      this.drawingName = ''
      this.pagination.current = 1
      this.fetchCommunityList()
    },
    async fetchCommunityList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          communityId: this.$route.query.communityId,
          drawingName: this.drawingName
        }
        const data = await queryCommunityDrawings(params)
        this.communityList = data
        this.pagination.total = data.length
      } catch (error) {
        this.$message.error(error.message || this.$t('enterCommunity.fetchError'))
      } finally {
        this.loading = false
      }
    },
    openEditDialog(community) {
      this.$refs.editDialog.open(community)
    },
    showHcUse() {
      this.showPage = 'hcUse'
    },
    goBack() {
      // this.showPage = 'myCommunity'
      this.$router.push(`/pages/common/enterCommunity`)
    },
    handlePageChange(page) {
      this.pagination.current = page
      this.fetchCommunityList()
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.fetchCommunityList()
    }
  }
}
</script>

<style scoped>
.enter-community-container {
  padding: 20px;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

.float-right {
  float: right;
}

.commercial-content {
  text-align: center;
  padding: 20px 0;
}

.commercial-content img {
  max-width: 100%;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>